import type {
  AiReviewStatus,
  RequirementGenerationStatus,
  RequirementGeneratedArtifacts,
  RequirementReviewStatus,
} from "@pericles/agent-orchestrator";

import { getEntitySlug } from "./entitySlug";

interface PaginatedResponse<T> {
  items: T[];
  meta?: {
    skip: number;
    take: number;
    total: number;
  };
}

export interface ProjectRequirementRecord {
  id: string;
  title?: string;
  description?: string;
  generationStatus?: RequirementGenerationStatus | string;
  reviewStatus?: RequirementReviewStatus | string;
  aiReviewStatus?: AiReviewStatus | null;
  generatedArtifacts?: RequirementGeneratedArtifacts | null;
}

interface RequirementsListResponse extends PaginatedResponse<ProjectRequirementRecord> {
  error?: string;
}

export async function fetchProjectRequirements(projectId: string): Promise<ProjectRequirementRecord[]> {
  if (!projectId) return [];

  const requirementEntity = getEntitySlug("Requirement");
  const filters = JSON.stringify({ projectId });
  const params = new URLSearchParams({
    page: "0",
    pageSize: "1000",
    filters,
  });

  const response = await fetch(`/api/entities/${requirementEntity}?${params.toString()}`);
  const payload = (await response.json()) as RequirementsListResponse;

  if (!response.ok) {
    const message = payload?.error ?? `Failed to load project requirements (status ${response.status})`;
    throw new Error(message);
  }

  return payload?.items ?? [];
}
